import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductOperatingSystemService } from '../../../services/product-operating-system.service';

@Component({
  selector: 'app-view-product-operating-systems',
  templateUrl: './view-product-operating-systems.component.html',
  styleUrls: ['./view-product-operating-systems.component.css'],
  providers:[ProductOperatingSystemService]
})
export class ViewProductOperatingSystemsComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  productOperatingSystem: any = {
    laptops: false,
    consoles: false,
    products: false,
    mobiles: false
  };
  constructor(private productOperatingSystemService:ProductOperatingSystemService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getProductOperatingSystem();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getProductOperatingSystem(){
    this.productOperatingSystemService.get(this.id).subscribe((productOperatingSystem) => {
      this.productOperatingSystem = productOperatingSystem;
    });
  }
  

  saveProductOperatingSystem(){
    this.parseProductsType();
    if (this.productOperatingSystem.id == undefined){
      this.productOperatingSystemService.create(this.returnProductOperatingSystemProperties(this.productOperatingSystem))
      .subscribe((productOperatingSystem) => {
        this.productOperatingSystemService.get(productOperatingSystem.id).subscribe((productOperatingSystem) => {
          this.productOperatingSystem = productOperatingSystem;
          this.router.navigate(['/configuration/productoperatingsystems']);
        });
      });
    }else{
      this.productOperatingSystemService.update(this.returnProductOperatingSystemProperties(this.productOperatingSystem))
      .subscribe((productOperatingSystem) => {
        this.productOperatingSystem = productOperatingSystem;
      });
    }
  }

  returnProductOperatingSystemProperties(productOperatingSystem){
    var properties = {
      name: productOperatingSystem.name,
      product_types: productOperatingSystem.product_types
    }
    if (productOperatingSystem.id){
      properties['id'] = productOperatingSystem.id;
    }
    return properties;
  }

  parseProductsType(){
    this.productOperatingSystem.product_types = "";
    if(this.productOperatingSystem.mobiles === true){
      this.productOperatingSystem.product_types += "1,";
    }
    if(this.productOperatingSystem.consoles === true){
      this.productOperatingSystem.product_types += "2,";
    }
    if(this.productOperatingSystem.products === true){
      this.productOperatingSystem.product_types += "3,";
    }
    if(this.productOperatingSystem.laptops === true){
      this.productOperatingSystem.product_types += "4,";
    }
    this.productOperatingSystem.product_types = this.productOperatingSystem.product_types.substring(0,this.productOperatingSystem.product_types.length - 1);
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-operating-systems/view-product-operating-systems/view-product-operating-systems.component.ts